import firebase from "firebase"
import firestore from "firebase/firestore"

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyB_ou0bxRSvEyg70fy2ucP6FTndFGgTFOY",
  authDomain: "ninja-chat0.firebaseapp.com",
  databaseURL: "https://ninja-chat0.firebaseio.com",
  projectId: "ninja-chat0",
  storageBucket: "ninja-chat0.appspot.com",
  messagingSenderId: "1086287817711",
  appId: "1:1086287817711:web:51f8562111ae5215c6641a"
};
// Initialize Firebase
const firebaseapp = firebase.initializeApp(firebaseConfig);
export default  firebaseapp.firestore()





// WEBPACK FOOTER //
// ./src/firebase/init.js